import { render } from "./ItemCounter.vue?vue&type=template&id=3346831b&scoped=true"
import script from "./ItemCounter.vue?vue&type=script&lang=js"
export * from "./ItemCounter.vue?vue&type=script&lang=js"

import "./ItemCounter.vue?vue&type=style&index=0&id=3346831b&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3346831b"]])

export default __exports__